export default __webpack_public_path__ + "static/media/polaroid3.6abe7a68.jpg";